<app-header></app-header>
<app-page-title></app-page-title>

<div class="container-fluid page-container">
  <!-- Page content -->
  <div class="page-content">
    <div class="card">
      <div class="card-header">
        <div class="row align-items-center">
          <div class="col-lg-4 col-md-4">
            <h5 class="card-title mb-0">
              <strong>{{ headingTitle }}</strong>
            </h5>
          </div>

          <!-- Navigation Tabs Start -->
          <div class="col-lg-8 col-md-8">
            <nav class="navbar navbar-expand-md p-0">
              <button class="navbar-toggler ms-auto" type="button" data-bs-toggle="collapse"
                      data-bs-target="#navbar-management-toggle" aria-controls="navbar-management-toggle"
                      aria-expanded="false" aria-label="Toggle navigation">
                <i class="icon-tree5"></i>
              </button>

              <div class="collapse navbar-collapse" id="navbar-management-toggle">
                <ul class="navbar-nav ms-auto">
                  <li class="" [ngClass]="{'active': showIndustryList == 'indList'}">
                    <a class="nav-link"
                       [ngClass]="{'active-link': showIndustryList == 'indList', 'no-link': showIndustryList != 'indList'}"
                       (click)="switchView('indList')">Unit Station List</a>
                  </li>

                  <li class="" [ngClass]="{'active': showIndustryList == 'vendorManagement'}">
                    <a class="nav-link"
                       [ngClass]="{'active-link': showIndustryList == 'vendorManagement', 'no-link': showIndustryList != 'vendorManagement'}"
                       (click)="switchView('vendorManagement')">Vendor Management</a>
                  </li>

                  <li class="dropdown"
                      [ngClass]="{'active': (showIndustryList == 'officer' || showIndustryList == 'officerList')}">
                    <a class="nav-link" href="#" role="button" data-bs-toggle="dropdown"
                       aria-expanded="false" [ngClass]="{'active-link': (showIndustryList == 'officer' || showIndustryList == 'officerList'),
                                           'no-link': (showIndustryList != 'officer' && showIndustryList != 'officerList')}">
                      Officer Management
                    </a>
                    <ul class="dropdown-menu">
                      <li [ngClass]="{'active': showIndustryList == 'officerList'}">
                        <a class="dropdown-item"
                           [ngClass]="{'active-link': showIndustryList == 'officerList', 'no-link': showIndustryList != 'officerList'}"
                           (click)="switchView('officerList')">Officer List</a>
                      </li>
                      <li [ngClass]="{'active': showIndustryList == 'officer'}">
                        <a class="dropdown-item"
                           [ngClass]="{'active-link': showIndustryList == 'officer', 'no-link': showIndustryList != 'officer'}"
                           (click)="switchView('officer')">Add Officer</a>
                      </li>
                    </ul>
                  </li>

                  <li class="dropdown"
                      [ngClass]="{'active': (showIndustryList == 'officeType' || showIndustryList == 'officeAdmin')}">
                    <a class="nav-link" href="#" role="button" data-bs-toggle="dropdown"
                       aria-expanded="false" [ngClass]="{'active-link': (showIndustryList == 'officeType' || showIndustryList == 'officeAdmin'),
                                           'no-link': (showIndustryList != 'officeType' && showIndustryList != 'officeAdmin')}">
                      Administration Management
                    </a>
                    <ul class="dropdown-menu">
                      <li [ngClass]="{'active': showIndustryList == 'officeAdmin'}">
                        <a class="dropdown-item"
                           [ngClass]="{'active-link': showIndustryList == 'officeAdmin', 'no-link': showIndustryList != 'officeAdmin'}"
                           (click)="switchView('officeAdmin')">Office Administration</a>
                      </li>
                      <li [ngClass]="{'active': showIndustryList == 'officeType'}">
                        <a class="dropdown-item"
                           [ngClass]="{'active-link': showIndustryList == 'officeType', 'no-link': showIndustryList != 'officeType'}"
                           (click)="switchView('officeType')">Office Type Administration</a>
                      </li>
                      <li [ngClass]="{'active': showIndustryList == 'district'}">
                        <a class="dropdown-item"
                           [ngClass]="{'active-link': showIndustryList == 'district', 'no-link': showIndustryList != 'district'}"
                           (click)="switchView('district')">District Administration</a>
                      </li>
                      <li [ngClass]="{'active': showIndustryList == 'tehsil'}">
                        <a class="dropdown-item"
                           [ngClass]="{'active-link': showIndustryList == 'tehsil', 'no-link': showIndustryList != 'tehsil'}"
                           (click)="switchView('tehsil')">Tehsil Administration</a>
                      </li>
                      <li [ngClass]="{'active': showIndustryList == 'group'}">
                        <a class="dropdown-item"
                           [ngClass]="{'active-link': showIndustryList == 'group', 'no-link': showIndustryList != 'group'}"
                           (click)="switchView('group')">Group Administration</a>
                      </li>
                      <li [ngClass]="{'active': showIndustryList == 'subRegion'}">
                        <a class="dropdown-item"
                           [ngClass]="{'active-link': showIndustryList == 'subRegion', 'no-link': showIndustryList != 'subRegion'}"
                           (click)="switchView('subRegion')">Manage Sub Region Administration</a>
                      </li>
                      <li [ngClass]="{'active': showIndustryList == 'officerType'}">
                        <a class="dropdown-item"
                           [ngClass]="{'active-link': showIndustryList == 'officerType', 'no-link': showIndustryList != 'officerType'}"
                           (click)="switchView('officerType')">Add Type of Officer</a>
                      </li>
                      <li [ngClass]="{'active': showIndustryList == 'role'}">
                        <a class="dropdown-item"
                           [ngClass]="{'active-link': showIndustryList == 'role', 'no-link': showIndustryList != 'role'}"
                           (click)="switchView('role')">Role Management Administration</a>
                      </li>
                      <li [ngClass]="{'active': showIndustryList == 'attachDistrict'}">
                        <a class="dropdown-item"
                           [ngClass]="{'active-link': showIndustryList == 'attachDistrict', 'no-link': showIndustryList != 'attachDistrict'}"
                           (click)="switchView('attachDistrict')">Attach District in Groups</a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
          <!-- Navigation Tabs Ends -->
        </div>
      </div>

      <div class="card-body">
        <!-- Your content will go here -->

        <div class="clearfix"></div>
        <!-- Industry Management Start -->

        <div class="table-responsive">
          <table class="table table-hover align-middle" *ngIf="showIndustryList == 'indList'">
            <thead class="table-light">
            <tr>
              <th *ngIf="state == 'Delhi'" class="border-0">S No.</th>
              <th class="border-0">Unit Station Code</th>
              <th class="border-0">Unit Station Name</th>
              <th class="border-0">Category Name</th>
              <th class="border-0">Vendor Name</th>
              <th class="border-0">OCMMS ID</th>
              <th class="border-0">Category Type</th>
              <th class="border-0">Officer</th>
              <th class="border-0 text-end">Action</th>
            </tr>
            </thead>

            <tbody *ngIf="!industryListLoader && allIndustriesDetails.length">
            <tr *ngFor="let industry of allIndustriesDetails; let i = index" [attr.data-index]="i">
              <td *ngIf="state == 'Delhi'">{{ i + 1 }}</td>
              <td>{{ industry.code }}</td>
              <td class="text-capitalize" [title]="industry.name">
                {{ (industry.name.length > 20) ? (industry.name | slice:0:20) + '...' : industry.name }}
              </td>
              <td class="text-capitalize">
                <input autocomplete="off" pattern="^[^<>]*$"

                       [ngModelOptions]="{standalone: true}" [(ngModel)]="searchField[industry.id]['industryType']"
                       type="text" class="form-control form-control-sm"
                       placeholder="Enter Industry Type">
              </td>
              <td class="text-capitalize">{{ industry.vendor_short_name }}</td>
              <td class="text-capitalize">
                <input [ngModelOptions]="{standalone: true}" [(ngModel)]="searchField[industry.id]['ocmmsId']"
                       type="text" class="form-control form-control-sm"
                       placeholder="Enter OCMMS ID">
              </td>
              <td class="text-capitalize">
                <input [ngModelOptions]="{standalone: true}" [(ngModel)]="searchField[industry.id]['category']"
                       type="text" class="form-control form-control-sm"
                       placeholder="Enter Category Type">
              </td>
              <td class="text-capitalize">
                <select [ngModelOptions]="{standalone: true}" [(ngModel)]="searchField[industry.id]['officer']"
                        class="form-select form-select-sm">
                  <option value="">Select Officer</option>
                  <option *ngFor="let officer of officerList; let i = index"
                          [value]="officer.id">
                    {{ officer.name }} ({{ officer.region_name }})
                  </option>
                </select>
              </td>
              <td class="text-capitalize text-end">
                <div class="dropdown">
                  <button class="btn btn-sm btn-link text-dark"
                          type="button" data-bs-toggle="dropdown"
                          aria-expanded="false">
                    <i class="icon-menu9"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li>
                      <a class="dropdown-item" (click)="saveIndustryDetails(industry.id)">
                        <i class="icon icon-plus-circle2 me-2"></i>Add
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item text-danger" (click)="deleteIndustry(industry.id)">
                        <i class="icon icon-bin me-2"></i>Delete
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
            </tbody>

            <tbody *ngIf="!industryListLoader && !allIndustriesDetails.length">
            <tr>
              <td colspan="12" class="text-center py-5">
                <div class="badge bg-danger py-2 px-3 fs-6">No Unit Station Found</div>
              </td>
            </tr>
            </tbody>

            <tbody *ngIf="industryListLoader">
            <tr>
              <td colspan="12" class="text-center py-5">
                <div class="d-flex justify-content-center">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <!-- Industry Management End -->

        <!-- Vendor Management Start -->
        <div class="table-responsive">
          <table class="table table-hover align-middle" *ngIf="showIndustryList == 'vendorManagement'">
            <thead class="table-light">
            <tr>
              <th *ngIf="state == 'Delhi'" class="border-0">S No.</th>
              <th class="border-0">Vendor Full Name</th>
              <th class="border-0">Vendor Short Name</th>
              <th class="border-0">User Id</th>
              <th class="border-0 text-end">Action</th>
            </tr>
            </thead>

            <tbody *ngIf="!vendorListLoader && vendorList.length">
            <tr *ngFor="let vendor of vendorList; let i = index" [attr.data-index]="i">
              <td *ngIf="state == 'Delhi'">{{ i + 1 }}</td>

              <td class="text-capitalize">
                <ng-container *ngIf="vendorEdit['vendor_'+vendor.id]; else viewVendorName">
                  <input type="text" [ngModelOptions]="{standalone: true}"
                         [(ngModel)]="vendorUser['vendor_'+vendor.id]['vendor_name']"
                         placeholder="Enter Vendor Name" class="form-control form-control-sm">
                </ng-container>
                <ng-template #viewVendorName>
                  {{ vendor.vendor_name }}
                </ng-template>
              </td>

              <td class="text-capitalize">
                <ng-container *ngIf="vendorEdit['vendor_'+vendor.id]; else viewShortName">
                  <input type="text" [ngModelOptions]="{standalone: true}"
                         [(ngModel)]="vendorUser['vendor_'+vendor.id]['vendor_short_name']"
                         placeholder="Enter Vendor Short Name" class="form-control form-control-sm">
                </ng-container>
                <ng-template #viewShortName>
                  {{ vendor.vendor_short_name }}
                </ng-template>
              </td>

              <td class="text-capitalize">
                <ng-container *ngIf="vendorEdit['vendor_'+vendor.id]; else viewUserId">
                  <input type="text" [ngModelOptions]="{standalone: true}"
                         [(ngModel)]="vendorUser['vendor_'+vendor.id]['user_profile_id']"
                         placeholder="Enter Vendor User Id" class="form-control form-control-sm">
                </ng-container>
                <ng-template #viewUserId>
                  {{ vendor.user_profile_id }}
                </ng-template>
              </td>

              <td class="text-end">
                <div class="dropdown">
                  <button class="btn btn-sm btn-link text-dark"
                          type="button" data-bs-toggle="dropdown"
                          aria-expanded="false">
                    <i class="icon-menu9"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li *ngIf="!vendorEdit['vendor_'+vendor.id]">
                      <a class="dropdown-item" (click)="setVendorToUpdate(vendor)">
                        <i class="icon icon-pencil me-2"></i>Edit
                      </a>
                    </li>
                    <li *ngIf="!vendorEdit['vendor_'+vendor.id]">
                      <a class="dropdown-item" (click)="generateVendorApiKey(vendor)" title="Generate New API Key">
                        <i class="icon icon-key me-2"></i>Generate API Key
                      </a>
                    </li>
                    <li *ngIf="!vendorEdit['vendor_'+vendor.id]">
                      <a class="dropdown-item" (click)="generateNewPassword(vendor)" title="Generate New Password">
                        <i class="icon icon-lock me-2"></i>Generate Password
                      </a>
                    </li>
                    <li *ngIf="vendorEdit['vendor_'+vendor.id]">
                      <a class="dropdown-item text-danger" (click)="cancelVendorUpdate()">
                        <i class="icon icon-cross me-2"></i>Cancel
                      </a>
                    </li>
                    <li *ngIf="vendorEdit['vendor_'+vendor.id]">
                      <a class="dropdown-item text-success" (click)="updateVendorDetail()">
                        <i class="icon icon-reload-alt me-2"></i>Update
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
            </tbody>

            <tbody *ngIf="!vendorListLoader && !vendorList.length">
            <tr>
              <td colspan="12" class="text-center py-5">
                <div class="badge bg-danger py-2 px-3 fs-6">No Vendor Available</div>
              </td>
            </tr>
            </tbody>

            <tbody *ngIf="vendorListLoader">
            <tr>
              <td colspan="12" class="text-center py-5">
                <div class="d-flex justify-content-center">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <!-- Vendor Management End -->

        <!-- Officer Management Start -->
        <div class="table-responsive">
          <table class="table table-hover align-middle" *ngIf="showIndustryList == 'officerList'">
            <thead class="table-light">
            <tr>
              <th *ngIf="state == 'Delhi'" class="border-0">S No.</th>
              <th class="border-0">Name</th>
              <th class="border-0">Email</th>
              <th class="border-0">Contact Number</th>
              <th class="border-0">Region</th>
              <th class="border-0 text-end">Action</th>
            </tr>
            </thead>

            <tbody *ngIf="!officerLoader && officerList.length">
            <tr *ngFor="let officer of officerList; let i = index" [attr.data-index]="i">
              <td *ngIf="state == 'Delhi'">{{ i + 1 }}</td>

              <td>
                <ng-container *ngIf="showEdit['ind_'+officer.id]; else viewOfficerName">
                  <input type="text" [ngModelOptions]="{standalone: true}"
                         [(ngModel)]="userToUpdate['ind_'+officer.id]['name']"
                         placeholder="Enter Officer Name" class="form-control form-control-sm">
                </ng-container>
                <ng-template #viewOfficerName>
                  {{ officer.name }}
                </ng-template>
              </td>

              <td>
                <ng-container *ngIf="showEdit['ind_'+officer.id]; else viewOfficerEmail">
                  <input type="email" [ngModelOptions]="{standalone: true}"
                         [(ngModel)]="userToUpdate['ind_'+officer.id]['email']"
                         placeholder="Enter Officer Email" class="form-control form-control-sm">
                </ng-container>
                <ng-template #viewOfficerEmail>
                  {{ officer.email }}
                </ng-template>
              </td>

              <td>
                <ng-container *ngIf="showEdit['ind_'+officer.id]; else viewOfficerContact">
                  <input type="tel" [ngModelOptions]="{standalone: true}"
                         [(ngModel)]="userToUpdate['ind_'+officer.id]['contact_number']"
                         placeholder="Enter Contact Number" class="form-control form-control-sm">
                </ng-container>
                <ng-template #viewOfficerContact>
                  {{ officer.contact_number }}
                </ng-template>
              </td>

              <td>
                <ng-container *ngIf="showEdit['ind_'+officer.id]; else viewOfficerRegion">
                  <input type="text" [ngModelOptions]="{standalone: true}"
                         [(ngModel)]="userToUpdate['ind_'+officer.id]['region_name']"
                         placeholder="Enter Region Name" class="form-control form-control-sm">
                </ng-container>
                <ng-template #viewOfficerRegion>
                  {{ officer.region_name }}
                </ng-template>
              </td>

              <td class="text-end">
                <div class="btn-group" *ngIf="showEdit['ind_'+officer.id]; else editDropdown">
                  <button class="btn btn-sm btn-danger" (click)="cancelUpdate()" title="Cancel">
                    <i class="icon icon-cross"></i>
                  </button>
                  <button class="btn btn-sm btn-success" (click)="updateOfficer()" title="Update">
                    <i class="icon icon-check"></i>
                  </button>
                </div>

                <ng-template #editDropdown>
                  <div class="dropdown">
                    <button class="btn btn-sm btn-link text-dark"
                            type="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                      <i class="icon-menu9"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                      <li>
                        <a class="dropdown-item" (click)="setOfficerToUpdate(officer)">
                          <i class="icon icon-pencil me-2"></i> Edit
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" (click)="deleteOfficer(officer)">
                          <i class="icon icon-cross me-2"></i> Delete
                        </a>
                      </li>
                    </ul>
                  </div>
                </ng-template>
              </td>
            </tr>
            </tbody>

            <tbody *ngIf="!officerLoader && !officerList.length">
            <tr>
              <td colspan="12" class="text-center py-5">
                <div class="badge bg-danger py-2 px-3 fs-6">No Officer Found</div>
              </td>
            </tr>
            </tbody>

            <tbody *ngIf="officerLoader">
            <tr>
              <td colspan="12" class="text-center py-5">
                <div class="d-flex justify-content-center">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="card-body" *ngIf="showIndustryList == 'officer'">
          <form class="row g-3 needs-validation" novalidate>
            <div class="col-md-6 mb-3">
              <label for="officerName" class="form-label">Officer Name*</label>
              <input type="text" class="form-control" id="officerName"
                     [ngModelOptions]="{standalone: true}" [(ngModel)]="userDetails['name']"
                     placeholder="Enter Officer Name"
                     autocomplete="off"
                     pattern="^[^<>]*$"
                     required>
              <div *ngIf="formErrorName && error" class="invalid-feedback d-block">
                *{{ formErrorName }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label for="officerEmail" class="form-label">Officer Email*</label>
              <input type="email" class="form-control" id="officerEmail"
                     [ngModelOptions]="{standalone: true}" [(ngModel)]="userDetails['email']"
                     placeholder="Enter Officer Email Id"
                     required>
              <div *ngIf="formErrorEmail && error" class="invalid-feedback d-block">
                *{{ formErrorEmail }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label for="officerContact" class="form-label">Officer Contact*</label>
              <input type="tel" class="form-control" id="officerContact"
                     [ngModelOptions]="{standalone: true}" [(ngModel)]="userDetails['contact']"
                     placeholder="Enter Officer Contact Number"
                     required>
              <div *ngIf="formErrorContact && error" class="invalid-feedback d-block">
                *{{ formErrorContact }}
              </div>
            </div>

            <div class="col-md-6 mb-3">
              <label for="officerRegion" class="form-label">Officer Region*</label>
              <input type="text" class="form-control" id="officerRegion"
                     [ngModelOptions]="{standalone: true}" [(ngModel)]="userDetails['region']"
                     placeholder="Enter Officer Region Name"
                     required>
              <div *ngIf="formErrorRegion && error" class="invalid-feedback d-block">
                *{{ formErrorRegion }}
              </div>
            </div>

            <div class="col-12">
              <div class="d-flex justify-content-end">
                <button type="button" (click)="validateUser()"
                        class="btn btn-primary px-4">
                  <strong>Save</strong>
                </button>
              </div>
            </div>
          </form>
        </div>
        <!-- Officer Management end -->
        <!-- HSPCB Managament Start-->

        <div class="panel-body" *ngIf="showIndustryList == 'officeAdmin'">
          <div class="form-horizontal">
            <fieldset class="content-group">
              <div class="mb-3">
                <button *ngIf="officeAdminView != 'add'"
                        (click)="setOfficeViewDetails('add')"
                        type="button"
                        class="btn btn-success float-end">
                  <strong>Add New Office</strong>
                </button>
              </div>
            </fieldset>
          </div>

          <div class="form-horizontal" *ngIf="officeAdminView == 'add'">
            <fieldset class="content-group">
              <div class="mb-3">
                <button *ngIf="officeAdminView == 'add'"
                        (click)="officeAdminView = 'list'"
                        type="button"
                        class="btn btn-success float-end">
                  <strong>List All Office</strong>
                </button>
              </div>
            </fieldset>

            <fieldset class="content-group">
              <div class="mb-3 row">
                <label class="col-form-label col-lg-2">Office Name*</label>
                <div class="col-lg-10">
                  <input type="text"
                         [ngModelOptions]="{standalone: true}" [(ngModel)]="officeName"
                         placeholder="Enter Office Name"
                         class="form-control">
                  <div *ngIf="formofficeNameError && errorOfficeName">
                    <span class="text-danger fw-bold ms-1">*{{ formofficeNameError }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3 row">
                <div class="col-lg-12">
                  <button (click)="saveOfficeName()"
                          type="submit"
                          class="btn btn-primary float-end">
                    <strong>Save</strong>
                  </button>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="table-responsive">
            <table class="table" *ngIf="officeAdminView == 'list'">
              <thead>
              <tr>
                <th *ngIf="state == 'Delhi'">S No.</th>
                <th>Office Name</th>
                <th class="text-end">Action</th>
              </tr>
              </thead>
              <tbody *ngIf="!officeListLoader && officeList.length">
              <tr *ngFor="let office of officeList let i = index" [attr.data-index]="i">
                <td *ngIf="state == 'Delhi'">{{ i + 1 }}</td>
                <td>
                  <span *ngIf="!showOfficeEdit['status_'+office.id]">{{ office.office_name }}</span>
                  <span *ngIf="showOfficeEdit['status_'+office.id]">
                            <input type="text"
                                   [ngModelOptions]="{standalone: true}"
                                   [(ngModel)]="showOfficeEdit['office_'+office.id]['office_name']"
                                   placeholder="Enter Office Name"
                                   class="form-control w-50">
                            <div *ngIf="formEditOfficeNameError && errorEditOfficeName">
                                <span class="text-danger fw-bold ms-1">*{{ formEditOfficeNameError }}</span>
                            </div>
                        </span>
                </td>
                <td class="text-end">
                  <div class="dropdown">
                    <button class="btn btn-link p-0"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false">
                      <i class="icon-menu9"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                      <li *ngIf="!showOfficeEdit['status_'+office.id]">
                        <a class="dropdown-item" (click)="setOfficeToUpdate(office)">
                          <i class="icon-pencil me-1"></i> Edit
                        </a>
                        <a class="dropdown-item" (click)="updateOfficeName(office, showOfficeEdit, 'delete')">
                          <i class="icon-cross me-1"></i> Delete
                        </a>
                      </li>
                      <li *ngIf="showOfficeEdit['status_'+office.id]">
                        <a class="dropdown-item" (click)="ValidateUpdateOffice(office, showOfficeEdit, 'edit')">
                          <i class="icon-pencil me-1"></i> Update
                        </a>
                        <a class="dropdown-item" (click)="cancelUpdateOffice()">
                          <i class="icon-cross me-1"></i> Cancel
                        </a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
              </tbody>
              <tbody *ngIf="!officeListLoader && !officeList.length">
              <tr>
                <td colspan="12" class="text-center py-5">
                  <span class="badge bg-danger">No Office Found</span>
                </td>
              </tr>
              </tbody>
              <tbody *ngIf="officeListLoader">
              <tr>
                <td colspan="12" class="text-center py-5">
                  <img src="/assets/images/load.gif" alt="Loading..."/>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="panel-body" *ngIf="showIndustryList == 'officeType'">
          <div class="form-horizontal">
            <fieldset class="content-group">
              <div class="mb-3">
                <button *ngIf="officeTypeView != 'add' && officeTypeView != 'edit'"
                        (click)="changeOfficeTypeInternalView('add')"
                        type="button"
                        class="btn btn-success float-end">
                  <strong>Add New Office Type</strong>
                </button>
              </div>
            </fieldset>
          </div>

          <div class="form-horizontal" *ngIf="officeTypeView == 'add' || officeTypeView == 'edit'">
            <fieldset class="content-group">
              <div class="mb-3">
                <button *ngIf="officeTypeView == 'add'"
                        (click)="officeTypeView = 'list'"
                        type="button"
                        class="btn btn-success float-end me-3">
                  <strong>List All Office Type</strong>
                </button>
              </div>
            </fieldset>

            <fieldset class="content-group">
              <div class="mb-3 row">
                <label class="col-form-label col-lg-2">Office Name*</label>
                <div class="col-lg-10">
                  <select [disabled]="(officeTypeView == 'edit')?true:false"
                          [ngModelOptions]="{standalone: true}" [(ngModel)]="officeTypeOfficeName"
                          class="form-select">
                    <option value=""> Select Office Name</option>
                    <option *ngFor="let office of officeList let i = index"
                            [attr.data-index]="i"
                            value="{{office.id}}">
                      {{ office.office_name }}
                    </option>
                  </select>
                  <div *ngIf="officeTypeOfficeNameError && officeTypeError">
                    <span class="text-danger fw-bold ms-1">*{{ officeTypeOfficeNameError }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3 row">
                <label class="col-form-label col-lg-2">Office Type*</label>
                <div class="col-lg-10">
                  <div class="mb-2" *ngFor="let item of [].constructor(officeTypeCount+1); let i = index">
                    <div *ngIf="i == 0 && officeTypeInput[i]">
                      <input [ngModelOptions]="{standalone: true}" [(ngModel)]="officeType[i]"
                             type="text"
                             class="form-control"
                             placeholder="Enter office type">
                    </div>

                    <div class="input-group mb-2" *ngIf="i != 0 && officeTypeInput[i]">
                      <input [ngModelOptions]="{standalone: true}" [(ngModel)]="officeType[i]"
                             type="text"
                             class="form-control"
                             placeholder="Enter Office Type Name">
                      <button class="btn btn-outline-danger"
                              type="button"
                              (click)="removeOfficeType(i)">
                        <i class="icon-bin"></i>
                      </button>
                    </div>
                  </div>

                  <div *ngIf="officeTypeNameError && officeTypeError">
                    <span class="text-danger fw-bold ms-1">*{{ officeTypeNameError }}</span>
                  </div>

                  <button (click)="addMoreOfficeType()"
                          class="btn btn-sm btn-primary rounded-pill">
                    <i class="icon-add me-1"></i> Add More
                  </button>
                </div>
              </div>

              <div class="mb-3 row">
                <div class="col-lg-12">
                  <button *ngIf="officeTypeView == 'add'"
                          (click)="saveOfficeType('add')"
                          type="submit"
                          class="btn btn-primary float-end">
                    <strong>Save</strong>
                  </button>

                  <button *ngIf="officeTypeView == 'edit'"
                          (click)="saveOfficeType('edit')"
                          type="submit"
                          class="btn btn-primary float-end">
                    <strong>Update</strong>
                  </button>
                  <button *ngIf="officeTypeView == 'edit'"
                          (click)="changeOfficeTypeInternalView('list')"
                          type="submit"
                          class="btn btn-danger float-end mx-2">
                    <strong>Cancel</strong>
                  </button>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="table-responsive">
            <table class="table" *ngIf="officeTypeView == 'list'">
              <thead>
              <tr>
                <th *ngIf="state == 'Delhi'">S No.</th>
                <th>Office Name</th>
                <th>Office Type</th>
                <th class="text-end">Action</th>
              </tr>
              </thead>

              <tbody *ngIf="!officeListLoader && officeList.length">
              <tr *ngFor="let officeType of officeListView let i = index" [attr.data-index]="i">
                <td *ngIf="state == 'Delhi'">{{ i + 1 }}</td>
                <td>{{ officeType.office_name }}</td>
                <td>
                        <span class="badge bg-primary me-1"
                              *ngFor="let type of officeType.types | parameterSplit | keyvalue">
                            {{ type.value }}
                        </span>
                </td>
                <td class="text-end">
                  <div class="dropdown">
                    <button class="btn btn-link p-0"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false">
                      <i class="icon-menu9"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                      <li *ngIf="!showOfficeTypeEdit['typeStatus_'+officeType.id]">
                        <a class="dropdown-item" (click)="setOfficeTypeToUpdate(officeType)">
                          <i class="icon-pencil me-1"></i> Edit
                        </a>
                        <a class="dropdown-item" (click)="updateOfficeType(officeType, showOfficeTypeEdit, 'delete')">
                          <i class="icon-cross me-1"></i> Delete
                        </a>
                      </li>
                      <li *ngIf="showOfficeTypeEdit['typeStatus_'+officeType.id]">
                        <a class="dropdown-item" (click)="ValidateUpdateOffice(officeType, showOfficeTypeEdit, 'edit')">
                          <i class="icon-pencil me-1"></i> Update
                        </a>
                        <a class="dropdown-item" (click)="cancelUpdateOfficeType()">
                          <i class="icon-cross me-1"></i> Cancel
                        </a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
              </tbody>
              <tbody *ngIf="!officeListViewLoader && !officeListView.length">
              <tr>
                <td colspan="12" class="text-center py-5">
                  <span class="badge bg-danger">No Office Type Found</span>
                </td>
              </tr>
              </tbody>
              <tbody *ngIf="officeListViewLoader">
              <tr>
                <td colspan="12" class="text-center py-5">
                  <img src="/assets/images/load.gif" alt="Loading..."/>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="panel-body" *ngIf="showIndustryList == 'district'">

          <div class="form-horizontal">
            <fieldset class="content-group">
              <div class="form-group">
                <button *ngIf="districtInternalView != 'add'"
                        (click)="districtInternalView = 'add'; errorDistrict = false;" type="button"
                        class="btn pull-right btn-success">
                  <strong>Add New District</strong>
                </button>
              </div>
            </fieldset>
          </div>

          <div class="form-horizontal" *ngIf="districtInternalView == 'add'">

            <fieldset class="content-group">
              <div class="form-group">
                <button *ngIf="districtInternalView == 'add'"
                        (click)="districtInternalView = 'list'; showDistrictEdit = [];" type="button"
                        class="btn pull-right btn-success">
                  <strong>List District</strong>
                </button>
              </div>
            </fieldset>

            <fieldset class="content-group">

              <div class="form-group">
                <label class="control-label col-lg-2">District Code*</label>
                <div class="col-lg-10">
                  <input type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="districtCode"
                         placeholder="Enter District Code" class="form-control">
                  <div *ngIf="formDistrictCodeError && errorDistrict">
                    <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{ formDistrictCodeError }}</span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-lg-2">District Name*</label>
                <div class="col-lg-10">
                  <input type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="districtName"
                         placeholder="Enter District Name" class="form-control">
                  <div *ngIf="formDistrictNameError && errorDistrict">
                    <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{ formDistrictNameError }}</span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="col-lg-12">
                  <button (click)="saveDistrict()" type="submit" class="btn pull-right btn-primary">
                    <strong>Save</strong>
                  </button>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="table-responsive">
            <table class="table datatable-show-all" *ngIf="districtInternalView == 'list'">

              <thead>
              <tr>
                <th *ngIf="state == 'Delhi'" style="border: none;">S No.</th>
                <th style="border: none;">District Code</th>
                <th style="border: none;">District Name</th>
                <th style="text-align: right; border: none;">Action</th>
              </tr>
              </thead>

              <tbody *ngIf="!districtLoader &&  officeList.length">
              <tr *ngFor="let district of districtList let i = index" [attr.data-index]="i">
                <td *ngIf="state == 'Delhi'">{{ i + 1 }}</td>
                <td>

                  <span *ngIf="!showDistrictEdit['status_'+district.id]">{{ district.district_code }}</span>

                  <span *ngIf="showDistrictEdit['status_'+district.id]">
                  <input type="text" [ngModelOptions]="{standalone: true}"
                         [(ngModel)]="showDistrictEdit['district_'+district.id]['district_code']"
                         placeholder="Enter District Code" class="form-control col-lg-6">
                  <div *ngIf="formEditDistrictCodeError&& errorEditDistrict">
                    <span
                      style=" margin-left: 5px; color: red; font-weight: 900;">*{{ formEditDistrictCodeError }}</span>
                  </div>
                </span>
                </td>

                <td>

                  <span *ngIf="!showDistrictEdit['status_'+district.id]">{{ district.district_name }}</span>

                  <span *ngIf="showDistrictEdit['status_'+district.id]">
                  <input type="text" [ngModelOptions]="{standalone: true}"
                         [(ngModel)]="showDistrictEdit['district_'+district.id]['district_name']"
                         placeholder="Enter District Name" class="form-control col-lg-6">
                  <div *ngIf="formEditDistrictNameError  && errorEditDistrict">
                    <span
                      style=" margin-left: 5px; color: red; font-weight: 900;">*{{ formEditDistrictNameError }}</span>
                  </div>
                </span>
                </td>

                <td style="text-align: right;">
                  <ul class="icons-list">
                    <!--                  <li class="dropdown">-->
                    <!--                    <a class="dropdown-toggle" data-toggle="dropdown">-->
                    <!--                      <i class="icon-menu9"></i>-->
                    <!--                    </a>-->
                    <!--                    <ul class="dropdown-menu dropdown-menu-right">-->
                    <!--                      <li *ngIf="!showDistrictEdit['status_'+district.id]">-->
                    <!--                        <a (click)="setDistrictToUpdate(district)"><i class="icon icon-pencil"></i> Edit</a>-->
                    <!--                        <a (click)="updateDistrict(district,showDistrictEdit, 'delete')"><i class="icon icon-cross"></i> Delete</a>-->
                    <!--                      </li>-->

                    <!--                      <li *ngIf="showDistrictEdit['status_'+district.id]">-->
                    <!--                        <a (click)="ValidateUpdateDistrict(district,showDistrictEdit, 'edit')"><i class="icon icon-pencil"></i> Update</a>-->
                    <!--                        <a (click)="cancelUpdateDistrict()"><i class="icon icon-cross"></i> Cancel</a>-->
                    <!--                      </li>-->
                    <!--                    </ul>-->
                    <!--                  </li>-->
                    <li class="dropdown">
                      <a class="dropdown-toggle" data-bs-toggle="dropdown">
                        <i class="icon-menu9"></i>
                      </a>
                      <ul class="dropdown-menu dropdown-menu-end">
                        <li *ngIf="!showDistrictEdit['status_'+district.id]">
                          <a class="dropdown-item" (click)="setDistrictToUpdate(district)">
                            <i class="icon icon-pencil"></i> Edit
                          </a>
                          <a class="dropdown-item" (click)="updateDistrict(district, showDistrictEdit, 'delete')">
                            <i class="icon icon-cross"></i> Delete
                          </a>
                        </li>

                        <li *ngIf="showDistrictEdit['status_'+district.id]">
                          <a class="dropdown-item" (click)="ValidateUpdateDistrict(district, showDistrictEdit, 'edit')">
                            <i class="icon icon-pencil"></i> Update
                          </a>
                          <a class="dropdown-item" (click)="cancelUpdateDistrict()">
                            <i class="icon icon-cross"></i> Cancel
                          </a>
                        </li>
                      </ul>
                    </li>

                  </ul>
                </td>

              </tr>
              </tbody>
              <tbody *ngIf="!districtLoader && !districtList.length">
              <tr>
                <td colspan="12" class="col-lg-12 text-center" style="height: 180px;">
                  <div class="label label-danger" style="margin-top: 50px;">No District Found</div>
                </td>
              </tr>
              </tbody>
              <tbody *ngIf="districtLoader">
              <tr>
                <td colspan="12" class="col-lg-12 text-center" style="height: 180px;">
                  <div style="margin-top: 50px;">
                    <img src="/assets/images/load.gif"/>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>


        </div>

        <div class="card-body" *ngIf="showIndustryList == 'tehsil'">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <button *ngIf="tehsilInternalView != 'add' && tehsilInternalView != 'edit'"
                        (click)="setTehsilValue('add')"
                        type="button"
                        class="btn btn-success float-end">
                  <strong>Add New Tehsil</strong>
                </button>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="tehsilInternalView == 'add'">
            <div class="col-12">
              <div class="mb-3">
                <button *ngIf="tehsilInternalView == 'add' || tehsilInternalView == 'edit'"
                        (click)="tehsilInternalView = 'list';"
                        type="button"
                        class="btn btn-success float-end me-3">
                  <strong>List Tehsil</strong>
                </button>
              </div>
            </div>

            <div class="col-12">
              <div class="mb-3 row">
                <label class="col-form-label col-sm-2">District Name*</label>
                <div class="col-sm-10">
                  <select [disabled]="tehsilInternalView == 'edit'"
                          [ngModelOptions]="{standalone: true}" [(ngModel)]="tehsilDistrict"
                          class="form-select">
                    <option value="">Select District</option>
                    <option *ngFor="let district of districtList let i = index"
                            [attr.data-index]="i"
                            value="{{district.id}}">
                      {{ district.district_name }} ({{ district.district_code }})
                    </option>
                  </select>
                  <div *ngIf="tehsilDistrictError && tehsilError">
                    <span class="text-danger fw-bold ms-2">*{{ tehsilDistrictError }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3 row">
                <label class="col-form-label col-sm-2">Tehsil Name*</label>
                <div class="col-sm-10">
                  <div class="mb-3" *ngFor="let item of [].constructor(TehsilCount+1); let i = index">
                    <div *ngIf="i == 0 && tehsilInput[i]" class="mb-2">
                      <input [ngModelOptions]="{standalone: true}" [(ngModel)]="tehsilName[i]"
                             type="text"
                             class="form-control"
                             placeholder="Enter Tehsil Name">
                    </div>

                    <div class="input-group mb-2" *ngIf="i != 0 && tehsilInput[i]">
                      <input [ngModelOptions]="{standalone: true}" [(ngModel)]="tehsilName[i]"
                             type="text"
                             class="form-control"
                             placeholder="Enter Tehsil Name">
                      <button class="btn btn-outline-danger"
                              type="button"
                              (click)="removeTehsil(i)">
                        <i class="bi bi-trash"></i>
                      </button>
                    </div>
                  </div>

                  <div *ngIf="tehsilNameError && tehsilError">
                    <span class="text-danger fw-bold ms-2">*{{ tehsilNameError }}</span>
                  </div>

                  <button (click)="addMoreTehsil()"
                          class="btn btn-sm btn-primary rounded-pill">
                    <i class="bi bi-plus"></i> Add More
                  </button>
                </div>
              </div>

              <div class="mb-3 row">
                <div class="col-12">
                  <button *ngIf="tehsilInternalView == 'add'"
                          (click)="saveTehsil('add')"
                          type="submit"
                          class="btn btn-primary float-end">
                    <strong>Save</strong>
                  </button>
                  <button *ngIf="tehsilInternalView == 'edit'"
                          (click)="saveTehsil('edit')"
                          type="submit"
                          class="btn btn-primary float-end">
                    <strong>Update</strong>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table table-striped" *ngIf="tehsilInternalView == 'list'">
              <thead>
              <tr>
                <th *ngIf="state == 'Delhi'" class="border-0">S No.</th>
                <th class="border-0">District Name</th>
                <th class="border-0">Tehsil Name</th>
                <th class="text-end border-0">Action</th>
              </tr>
              </thead>

              <tbody *ngIf="!tehsilLoader && tehsilList.length">
              <tr *ngFor="let tehsil of tehsilList let i = index" [attr.data-index]="i">
                <td *ngIf="state == 'Delhi'">{{ i + 1 }}</td>
                <td>{{ tehsil.district_name }}</td>
                <td>
            <span class="badge text-bg-primary me-1 mb-1"
                  *ngFor="let name of tehsil.tehsils | parameterSplit | keyvalue">
              {{ name.value }}
            </span>
                </td>
                <td class="text-end">
                  <div class="dropdown">
                    <button class="btn btn-link p-0"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false">
                      <i class="icon-menu9"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                      <li>
                        <a class="dropdown-item" (click)="setTehsilToUpdate(tehsil)">
                          <i class="bi bi-pencil me-2"></i> Edit
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" (click)="deleteTehsil(tehsil)">
                          <i class="bi bi-trash me-2"></i> Delete
                        </a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
              </tbody>

              <tbody *ngIf="!tehsilLoader && !tehsilList.length">
              <tr>
                <td colspan="12" class="text-center py-5">
                  <div class="badge text-bg-danger">No Tehsil Found</div>
                </td>
              </tr>
              </tbody>

              <tbody *ngIf="tehsilLoader">
              <tr>
                <td colspan="12" class="text-center py-5">
                  <div class="d-flex justify-content-center">
                    <div class="spinner-border" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="panel-body" *ngIf="showIndustryList == 'group'">
          <div class="form-horizontal">
            <fieldset class="content-group">
              <div class="mb-3">
                <button *ngIf="groupView != 'add' && groupView != 'edit'" (click)="setGroupView('add')" type="button"
                        class="btn btn-success float-end">
                  <strong>Add New Group</strong>
                </button>
              </div>
            </fieldset>
          </div>
          <div class="form-horizontal" *ngIf="groupView == 'add'">
            <fieldset class="content-group">
              <div class="mb-3">
                <button *ngIf="groupView == 'add' || groupView == 'edit'" (click)="groupView = 'list';" type="button"
                        class="btn btn-success float-end me-3">
                  <strong>List Group</strong>
                </button>
              </div>
            </fieldset>
            <fieldset class="content-group">
              <div class="mb-3 row">
                <label class="col-form-label col-lg-2">Office Type*</label>
                <div class="col-lg-10">
                  <select [disabled]="(groupView == 'edit')?true:false" [ngModelOptions]="{standalone: true}"
                          [(ngModel)]="groupOfficeType" class="form-select">
                    <option value=""> Select Office Type</option>
                    <option *ngFor="let officeType of officeTypeList let i = index" [attr.data-index]="i"
                            value="{{officeType.id}}">{{ officeType.office_type }}
                    </option>
                  </select>
                  <div *ngIf="groupOfficetypeError && groupError">
                    <span class="text-danger fw-bold ms-1">*{{ groupOfficetypeError }}</span>
                  </div>
                </div>
              </div>
              <div class="mb-3 row">
                <label class="col-form-label col-lg-2">Group Type*</label>
                <div class="col-lg-10">
                  <input type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="groupType"
                         placeholder="Enter Group Type" disabled class="form-control">
                  <div *ngIf="groupTypeError && groupError">
                    <span class="text-danger fw-bold ms-1">*{{ groupTypeError }}</span>
                  </div>
                </div>
              </div>
              <div class="mb-3 row">
                <label class="col-form-label col-lg-2">Group Name*</label>
                <div class="col-lg-10">
                  <div class="mb-2" *ngFor="let item of [].constructor(groupCount+1); let i = index">
                    <div *ngIf="i == 0 && groupInput[i]">
                      <input [ngModelOptions]="{standalone: true}" [(ngModel)]="groupName[i]" type="text"
                             class="form-control" placeholder="Enter Group Name">
                    </div>
                    <div class="input-group" *ngIf="i != 0 && groupInput[i]">
                      <input [ngModelOptions]="{standalone: true}" [(ngModel)]="groupName[i]" type="text"
                             class="form-control" placeholder="Enter Group Name">
                      <button style="cursor: pointer;" (click)="removeGroup(i)" class="btn btn-outline-danger"
                              type="button"><i class="bi bi-trash"></i></button>
                    </div>
                  </div>
                  <div *ngIf="groupNameError && groupError">
                    <span class="text-danger fw-bold ms-1">*{{ groupNameError }}</span>
                  </div>
                  <button (click)="addMoreGroup();" class="btn btn-primary btn-sm rounded-pill"><i
                    class="bi bi-plus"></i> Add More
                  </button>
                </div>
              </div>
              <div class="mb-3 row">
                <div class="col-lg-12">
                  <button *ngIf="groupView == 'add'" (click)="saveGroup('add')" type="submit"
                          class="btn btn-primary float-end">
                    <strong>Save</strong>
                  </button>
                  <button *ngIf="groupView == 'edit'" (click)="saveGroup('edit')" type="submit"
                          class="btn btn-primary float-end">
                    <strong>Update</strong>
                  </button>
                </div>
              </div>
            </fieldset>
          </div>
          <div class="table-responsive">
            <table class="table table-striped" *ngIf="groupView == 'list'">
              <thead>
              <tr>
                <th *ngIf="state == 'Delhi'">S No.</th>
                <th>Office Type</th>
                <th>Group Type</th>
                <th>Group Name</th>
                <th class="text-end">Action</th>
              </tr>
              </thead>
              <tbody *ngIf="!groupLoader && groupList.length">
              <tr *ngFor="let group of groupList let i = index" [attr.data-index]="i">
                <td *ngIf="state == 'Delhi'">{{ i + 1 }}</td>
                <td>{{ group.office_type }}</td>
                <td>{{ group.group_type }}</td>
                <td>
                        <span class="badge bg-primary me-1 mb-1"
                              *ngFor="let name of group.groups | parameterSplit | keyvalue">
                            {{ name.value }}
                        </span>
                </td>
                <td class="text-end">
                  <div class="dropdown">
                    <button class="btn btn-link p-0" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <i class="icon-menu9"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                      <li>
                        <a class="dropdown-item" (click)="setGroupToUpdate(group)">
                          <i class="bi bi-pencil me-2"></i>Edit
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" (click)="deleteGroup(group)">
                          <i class="bi bi-trash me-2"></i>Delete
                        </a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
              </tbody>
              <tbody *ngIf="!groupLoader && !groupList.length">
              <tr>
                <td colspan="12" class="text-center py-5">
                  <span class="badge bg-danger">No Group Found</span>
                </td>
              </tr>
              </tbody>
              <tbody *ngIf="groupLoader">
              <tr>
                <td colspan="12" class="text-center py-5">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="panel-body" *ngIf="showIndustryList == 'subRegion'">
          <div class="form-horizontal">
            <fieldset class="content-group">
              <div class="form-group">
                <button *ngIf="subRegionView != 'add' && subRegionView != 'edit'" (click)="setSubRegionView('add')"
                        type="button" class="btn btn-success float-end">
                  <strong>Add New Sub-Region</strong>
                </button>
              </div>
            </fieldset>
          </div>

          <div class="form-horizontal" *ngIf="subRegionView == 'add'">
            <fieldset class="content-group">
              <div class="form-group">
                <button *ngIf="subRegionView == 'add' || subRegionView == 'edit'" (click)="subRegionView = 'list';"
                        type="button" class="btn btn-success float-end me-3">
                  <strong>List Sub-Region</strong>
                </button>
              </div>
            </fieldset>

            <fieldset class="content-group">
              <div class="form-group mb-3">
                <label class="control-label col-lg-2">Office Type*</label>
                <div class="col-lg-10">
                  <select [ngModelOptions]="{standalone: true}" [(ngModel)]="subRegionOffice" (change)="getGroupName()"
                          class="form-control">
                    <option value=""> Select Office Type</option>
                    <option *ngFor="let officeType of officeTypeList let i = index" [attr.data-index]="i"
                            value="{{officeType.id}}">{{ officeType.office_type }}
                    </option>
                  </select>
                  <div *ngIf="subRegionOfficetypeError && subRegionError">
                    <span class="text-danger fw-bold ms-1">*{{ subRegionOfficetypeError }}</span>
                  </div>
                </div>
              </div>

              <div class="form-group mb-3">
                <label class="control-label col-lg-2">Group Type*</label>
                <div class="col-lg-10">
                  <input type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="subRegionGroupType"
                         placeholder="Enter Group Type" disabled class="form-control">
                  <div *ngIf="subRegionGroupTypeError && subRegionError">
                    <span class="text-danger fw-bold ms-1">*{{ subRegionGroupTypeError }}</span>
                  </div>
                </div>
              </div>

              <div class="form-group mb-3">
                <label class="control-label col-lg-2">Group Name*</label>
                <div class="col-lg-10">
                  <select [ngModelOptions]="{standalone: true}" [(ngModel)]="subRegionGroupName" class="form-control">
                    <option value=""> Select Group Name</option>
                    <option *ngFor="let group of subRegionGroupList let i = index" [attr.data-index]="i"
                            value="{{group.id}}">{{ group.group_name }}
                    </option>
                  </select>
                  <div *ngIf="subRegionGroupError && subRegionError">
                    <span class="text-danger fw-bold ms-1">*{{ subRegionGroupError }}</span>
                  </div>
                </div>
              </div>

              <div class="form-group mb-3">
                <label class="control-label col-lg-2">Sub Region Name*</label>
                <div class="col-lg-10">
                  <div class="mb-2" *ngFor="let item of [].constructor(subRegionCount+1); let i = index">
                    <div *ngIf=" i == 0 && subRegionInput[i]">
                      <input [ngModelOptions]="{standalone: true}" [(ngModel)]="subRegionName[i]" type="text"
                             class="form-control" placeholder="Enter Sub Region Name">
                    </div>

                    <div class="input-group" *ngIf=" i != 0 && subRegionInput[i]">
                      <input [ngModelOptions]="{standalone: true}" [(ngModel)]="subRegionName[i]" type="text"
                             class="form-control" placeholder="Enter Sub Region Name">
                      <span style="cursor: pointer;" (click)="removeSubRegion(i)"
                            class="input-group-text bg-danger text-white"><i class="bi bi-trash"></i></span>
                    </div>
                  </div>

                  <div *ngIf="subRegionNameError && subRegionError">
                    <span class="text-danger fw-bold ms-1">*{{ subRegionNameError }}</span>
                  </div>

                  <button (click)="addMoreSubRegion();" class="btn btn-sm btn-primary rounded-pill"><i
                    class="bi bi-plus"></i> Add More
                  </button>
                </div>
              </div>

              <div class="form-group">
                <div class="col-lg-12">
                  <button *ngIf="subRegionView == 'add'" (click)="saveSubRegion('add')" type="submit"
                          class="btn btn-primary float-end">
                    <strong>Save</strong>
                  </button>

                  <button *ngIf="subRegionView == 'edit'" (click)="saveSubRegion('edit')" type="submit"
                          class="btn btn-primary float-end">
                    <strong>Update</strong>
                  </button>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="table-responsive">
            <table class="table" *ngIf="subRegionView == 'list'">
              <thead>
              <tr>
                <th *ngIf="state == 'Delhi'">S No.</th>
                <th>Office Type</th>
                <th>Group Type</th>
                <th>Group Name</th>
                <th>Sub Regions</th>
                <th class="text-end">Action</th>
              </tr>
              </thead>

              <tbody *ngIf="!subRegionLoader && subRegionListAdmin.length">
              <tr *ngFor="let subRegion of subRegionListAdmin let i = index" [attr.data-index]="i">
                <td *ngIf="state == 'Delhi'">{{ i + 1 }}</td>
                <td>
                  {{ subRegion.office_type }}
                </td>
                <td>
                  CEMS
                </td>
                <td>
                  {{ subRegion.group_name }}
                </td>
                <td>
            <span class="badge bg-primary me-1 mb-1" *ngFor="let name of subRegion.regions | parameterSplit | keyvalue">
              {{ name.value }}
            </span>
                </td>
                <td class="text-end">
                  <div class="dropdown">
                    <button class="btn btn-link p-0" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <i class="icon-menu9"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                      <li>
                        <a class="dropdown-item" (click)="setSubRegionToUpdate(subRegion)">
                          <i class="bi bi-pencil me-2"></i>Edit
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" (click)="deleteSubRegion(subRegion)">
                          <i class="bi bi-trash me-2"></i>Delete
                        </a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
              </tbody>
              <tbody *ngIf="!subRegionLoader && !subRegionListAdmin.length">
              <tr>
                <td colspan="12" class="text-center py-5">
                  <div class="badge bg-danger mt-5">No Group Found</div>
                </td>
              </tr>
              </tbody>
              <tbody *ngIf="subRegionLoader">
              <tr>
                <td colspan="12" class="text-center py-5">
                  <div class="mt-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="panel-body" *ngIf="showIndustryList == 'officerType'">
          <div class="form-horizontal">
            <fieldset class="content-group">
              <div class="form-group">
                <button *ngIf="officerView != 'add'" (click)="setOfficerTypeView()" type="button"
                        class="btn btn-success float-end">
                  <strong>Add New Officer</strong>
                </button>
              </div>
            </fieldset>
          </div>

          <div class="form-horizontal" *ngIf="officerView == 'add'">
            <fieldset class="content-group">
              <div class="form-group">
                <button *ngIf="officerView == 'add'" (click)="officerView = 'list';" type="button"
                        class="btn btn-success float-end me-3">
                  <strong>List Officer</strong>
                </button>
              </div>
            </fieldset>

            <fieldset class="content-group">
              <div class="form-group mb-3">
                <label class="control-label col-lg-2">Officer Type*</label>
                <div class="col-lg-10">
                  <input type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="officerType"
                         placeholder="Enter Officer Type" class="form-control">
                  <div *ngIf="officerTypeError && errorOfficer">
                    <span class="text-danger fw-bold ms-1">*{{ officerTypeError }}</span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="col-lg-12">
                  <button (click)="saveOfficerType()" type="submit" class="btn btn-primary float-end">
                    <strong>Save</strong>
                  </button>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="table-responsive">
            <table class="table" *ngIf="officerView == 'list'">
              <thead>
              <tr>
                <th *ngIf="state == 'Delhi'">S No.</th>
                <th>Officer Type</th>
                <th class="text-end">Action</th>
              </tr>
              </thead>

              <tbody *ngIf="!officerTypeListLoader && officerTypeList.length">
              <tr *ngFor="let officer of officerTypeList let i = index" [attr.data-index]="i">
                <td *ngIf="state == 'Delhi'">{{ i + 1 }}</td>
                <td>
                  <span *ngIf="!showofficerTypeEdit['type_'+officer.id]">{{ officer.officer_type }}</span>
                  <span *ngIf="showofficerTypeEdit['type_'+officer.id]">
              <input type="text" [ngModelOptions]="{standalone: true}"
                     [(ngModel)]="officerTypeUpdate['type_'+officer.id]['officer_type']"
                     placeholder="Enter Officer Type" class="form-control">
              <div *ngIf="officerTypeUpdateError && errorOfficerUpdate">
                <span class="text-danger fw-bold ms-1">*{{ officerTypeUpdateError }}</span>
              </div>
            </span>
                </td>

                <td class="text-end">
                  <div class="dropdown">
                    <button class="btn btn-link p-0" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <i class="icon-menu9"></i>
                    </button>

                    <ul *ngIf="!showofficerTypeEdit['type_'+officer.id]" class="dropdown-menu dropdown-menu-end">
                      <li>
                        <a class="dropdown-item" (click)="setOfficerTypeToUpdate(officer)">
                          <i class="bi bi-pencil me-2"></i> Edit
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" (click)="deleteOfficerType(officer)">
                          <i class="bi bi-trash me-2"></i> Delete
                        </a>
                      </li>
                    </ul>

                    <ul *ngIf="showofficerTypeEdit['type_'+officer.id]" class="dropdown-menu dropdown-menu-end">
                      <li>
                        <a class="dropdown-item"
                           (click)="updateOfficerType(officer.id, officerTypeUpdate['type_'+officer.id])">
                          <i class="bi bi-pencil me-2"></i> Update
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" (click)="cancleOfficerType(officer)">
                          <i class="bi bi-x-circle me-2"></i> Cancel
                        </a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
              </tbody>

              <tbody *ngIf="!officerTypeListLoader && !officerTypeList.length">
              <tr>
                <td colspan="12" class="text-center py-5">
                  <div class="badge bg-danger mt-5">No Officer Found</div>
                </td>
              </tr>
              </tbody>

              <tbody *ngIf="officerTypeListLoader">
              <tr>
                <td colspan="12" class="text-center py-5">
                  <div class="mt-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="panel-body" *ngIf="showIndustryList == 'role'">
          <div class="form-horizontal">
            <fieldset class="content-group">
              <div class="mb-3">
                <button *ngIf="roleView != 'add' && roleView != 'edit'" (click)=" setRoleView('add');" type="button"
                        class="btn btn-success float-end">
                  <strong>Add New Role</strong>
                </button>
              </div>
            </fieldset>
          </div>

          <div class="form-horizontal" *ngIf="roleView == 'add' || roleView == 'edit'">
            <fieldset class="content-group">
              <div class="mb-3">
                <button *ngIf="roleView == 'add'" (click)="roleView = 'list';" type="button"
                        class="btn btn-success float-end" style="margin-right: 15px;">
                  <strong>List Role</strong>
                </button>
              </div>
            </fieldset>

            <fieldset class="content-group">
              <div class="mb-3 row">
                <label class="col-form-label col-lg-2">Office Type*</label>
                <div class="col-lg-10">
                  <select [ngModelOptions]="{standalone: true}" [(ngModel)]="roleOffice" id="roleOfficeSelect"
                          (change)="getAttachGroupName('role')" class="form-select">
                    <option value=""> Select Office Type</option>
                    <option *ngFor="let officeType of officeTypeList let i = index" [attr.data-index]="i"
                            value="{{officeType.id}}">{{ officeType.office_type }}
                    </option>
                  </select>
                  <div *ngIf="roleOfficetypeError && roleError">
                    <span class="text-danger fw-bold ms-1">*{{ roleOfficetypeError }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3 row">
                <label class="col-form-label col-lg-2">Group Name*</label>
                <div class="col-lg-10">
                  <select [ngModelOptions]="{standalone: true}" [(ngModel)]="roleGroupName"
                          (change)="getSubRegionList()" class="form-select">
                    <option value=""> Select Group Name</option>
                    <option *ngFor="let group of attachGroupList let i = index" [attr.data-index]="i"
                            value="{{group.id}}">{{ group.group_name }}
                    </option>
                  </select>
                  <div *ngIf="roleGroupError && roleError">
                    <span class="text-danger fw-bold ms-1">*{{ roleGroupError }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3 row">
                <label class="col-form-label col-lg-2">Role Name*</label>
                <div class="col-lg-10">
                  <input type="text" [ngModelOptions]="{standalone: true}" [(ngModel)]="roleName" maxlength="50"
                         placeholder="Enter Role Name" class="form-control">
                  <div *ngIf="roleNameError && roleError">
                    <span class="text-danger fw-bold ms-1">*{{ roleNameError }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3 row">
                <label class="col-form-label col-lg-2">Description*</label>
                <div class="col-lg-10">
                  <textarea [ngModelOptions]="{standalone: true}" [(ngModel)]="description" class="form-control"
                            cols="30" maxlength="100" rows="3"></textarea>
                  <div *ngIf="descriptionError && roleError">
                    <span class="text-danger fw-bold ms-1">*{{ descriptionError }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3 row">
                <label class="col-form-label col-lg-2">Scrutiny Right*</label>
                <div class="col-lg-10">
                  <select [ngModelOptions]="{standalone: true}" [(ngModel)]="scrutinyRight" class="form-select">
                    <option value="yes"> Yes</option>
                    <option value="no"> No</option>
                  </select>
                  <div *ngIf="scrutinyRightError && roleError">
                    <span class="text-danger fw-bold ms-1">*{{ scrutinyRightError }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3 row">
                <label class="col-form-label col-lg-2">Application Return Right*</label>
                <div class="col-lg-10">
                  <select [ngModelOptions]="{standalone: true}" [(ngModel)]="returnRight" class="form-select">
                    <option value="yes"> Yes</option>
                    <option value="no"> No</option>
                  </select>
                  <div *ngIf="returnRightError && roleError">
                    <span class="text-danger fw-bold ms-1">*{{ returnRightError }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3 row">
                <label class="col-form-label col-lg-2">Grant Trial consent*</label>
                <div class="col-lg-10">
                  <select [ngModelOptions]="{standalone: true}" [(ngModel)]="grantTrial" class="form-select">
                    <option value="yes"> Yes</option>
                    <option value="no"> No</option>
                  </select>
                  <div *ngIf="grantTrialError && roleError">
                    <span class="text-danger fw-bold ms-1">*{{ grantTrialError }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3 row">
                <label class="col-form-label col-lg-2">Grant Regular consent*</label>
                <div class="col-lg-10">
                  <select [ngModelOptions]="{standalone: true}" [(ngModel)]="grantRegular" class="form-select">
                    <option value="yes"> Yes</option>
                    <option value="no"> No</option>
                  </select>
                  <div *ngIf="grantRegularError && roleError">
                    <span class="text-danger fw-bold ms-1">*{{ grantRegularError }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3 row">
                <label class="col-form-label col-lg-2">Max no. of days assigned for application processing*</label>
                <div class="col-lg-10">
                  <select [ngModelOptions]="{standalone: true}" [(ngModel)]="assignedDays" class="form-select">
                    <option *ngFor="let dummy of ' '.repeat(50).split(''), let x = index" value="{{x+1}}"> {{ x + 1 }}
                      Days
                    </option>
                  </select>
                  <div *ngIf="assignedDaysError && roleError">
                    <span class="text-danger fw-bold ms-1">*{{ assignedDaysError }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3 row">
                <label class="col-form-label col-lg-2">Officer Type*</label>
                <div class="col-lg-10">
                  <select [ngModelOptions]="{standalone: true}" [(ngModel)]="roleOfficerType" class="form-select">
                    <option value=""> Select Officer Type</option>
                    <option *ngFor="let officerType of officerTypeList let i = index" [attr.data-index]="i"
                            value="{{officerType.id}}">{{ officerType.officer_type }}
                    </option>
                  </select>
                  <div *ngIf="roleOfficerTypeError && roleError">
                    <span class="text-danger fw-bold ms-1">*{{ roleOfficerTypeError }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3 row">
                <label class="col-form-label col-lg-2">Primary and Link Officer*</label>
                <div class="col-lg-10">
                  <select [ngModelOptions]="{standalone: true}" [(ngModel)]="roleLinkOfficer" class="form-select">
                    <option value=""> Select Officer</option>
                    <option *ngFor="let officer of roleOfficerList let i = index" [attr.data-index]="i"
                            value="{{officer.id}}"> {{ officer.employee_first_name }} {{ officer.employee_last_name }}
                      - {{ officer.id }}
                    </option>
                  </select>
                  <div *ngIf="roleLinkOfficerError && roleError">
                    <span class="text-danger fw-bold ms-1">*{{ roleLinkOfficerError }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3 row">
                <label class="col-form-label col-lg-2">Status of Role*</label>
                <div class="col-lg-10">
                  <select [ngModelOptions]="{standalone: true}" [(ngModel)]="roleStatus" class="form-select">
                    <option value=""> Select Role Status</option>
                    <option value="active"> Active</option>
                    <option value="inactive"> Inactive</option>
                  </select>
                  <div *ngIf="roleStatusError && roleError">
                    <span class="text-danger fw-bold ms-1">*{{ roleStatusError }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3 row">
                <label class="col-form-label col-lg-2">Can Do Inspection*</label>
                <div class="col-lg-10">
                  <select [ngModelOptions]="{standalone: true}" [(ngModel)]="canInspection" class="form-select">
                    <option value="no"> No</option>
                    <option value="yes"> Yes</option>
                  </select>
                  <div *ngIf="canInspectionError && roleError">
                    <span class="text-danger fw-bold ms-1">*{{ canInspectionError }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3 row">
                <label class="col-form-label col-lg-2">Sub Region*</label>
                <div class="col-lg-10">
                  <ng-multiselect-dropdown
                    [placeholder]="'Select Sub Region'"
                    [data]="subRegionList"
                    [ngModelOptions]="{standalone: true}" [(ngModel)]="roleSubRegionList"
                    [settings]="RoleSubRegiondropdownSettings"
                    (onSelect)="onItemSelect($event)"
                    (onSelectAll)="onSelectAll($event)">
                  </ng-multiselect-dropdown>
                  <div *ngIf="roleSubRegionError && roleError">
                    <span class="text-danger fw-bold ms-1">*{{ roleSubRegionError }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3 row">
                <div class="col-lg-12">
                  <button *ngIf="roleView == 'add'" (click)="addRole('add')" type="submit"
                          class="btn btn-primary float-end">
                    <strong>Save</strong>
                  </button>

                  <button *ngIf="roleView == 'edit'" style="margin-left: 10px; margin-right: 10px;"
                          (click)="addRole('edit')" type="submit" class="btn btn-primary float-end">
                    <strong>Update</strong>
                  </button>

                  <button *ngIf="roleView == 'edit'" (click)="CancelRoleEdit()" type="submit"
                          class="btn btn-danger float-end">
                    <strong>Cancel</strong>
                  </button>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="table-responsive">
            <table class="table" *ngIf="roleView == 'list'">
              <thead>
              <tr>
                <th *ngIf="state == 'Delhi'">S No.</th>
                <th>Role Name</th>
                <th>Office Type</th>
                <th>Group Name</th>
                <th>Officer Type</th>
                <th>Primary & Link Officer</th>
                <th>Status of Role</th>
                <th>Sub Region</th>
                <th class="text-end">Action</th>
              </tr>
              </thead>

              <tbody *ngIf="!roleListLoader && roleList.length">
              <tr *ngFor="let role of roleList let i = index" [attr.data-index]="i">
                <td *ngIf="state == 'Delhi'">{{ i + 1 }}</td>
                <td>
                  <span class="text-capitalize">{{ role.role_name }}</span>
                </td>
                <td>
                  <span class="text-capitalize">{{ role.office_type }}</span>
                </td>
                <td>
                  <span class="text-capitalize">{{ role.group_name }}</span>
                </td>
                <td>
                  <span class="text-capitalize">{{ role.officer_type }}</span>
                </td>
                <td>
                        <span class="text-capitalize"
                              *ngIf="roleOfficerOcmmsList && roleOfficerOcmmsList[role.ocmms_officer_id]">
                            {{ roleOfficerOcmmsList[role.ocmms_officer_id]['employee_first_name'] }} {{ roleOfficerOcmmsList[role.ocmms_officer_id]['employee_last_name'] }}
                        </span>
                  <span class="text-capitalize"> - {{ role.ocmms_officer_id }} </span>
                </td>
                <td>
                  <span class="text-capitalize">{{ role.role_status }}</span>
                </td>
                <td>
                        <span class="badge bg-primary text-capitalize me-1"
                              *ngFor="let subregion of role.sub_regions | parameterSplit | keyvalue">
                            {{ subregion.value }}
                        </span>
                </td>
                <td class="text-end">
                  <div class="dropdown">
                    <button class="btn btn-link p-0" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <i class="icon-menu9"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                      <li>
                        <a class="dropdown-item" (click)="editRole(role)">
                          <i class="icon-pencil me-1"></i> Edit
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" (click)="deleteRole(role.id)">
                          <i class="icon-cross me-1"></i> Delete
                        </a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
              </tbody>
              <tbody *ngIf="!roleListLoader && !roleList.length">
              <tr>
                <td colspan="12" class="text-center py-5">
                  <span class="badge bg-danger">No Role Found</span>
                </td>
              </tr>
              </tbody>
              <tbody *ngIf="roleListLoader">
              <tr>
                <td colspan="12" class="text-center py-5">
                  <img src="/assets/images/load.gif" alt="Loading..."/>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="panel-body" *ngIf="showIndustryList == 'attachDistrict'">
          <div class="form-horizontal">
            <fieldset class="content-group">
              <div class="mb-3">
                <button *ngIf="attachDistrictView != 'add' && attachDistrictView != 'edit'"
                        (click)="setAttachDistrictViewView('add');"
                        type="button"
                        class="btn btn-success float-end">
                  <strong>Attach New District</strong>
                </button>
              </div>
            </fieldset>
          </div>

          <div class="form-horizontal" *ngIf="attachDistrictView == 'add' || attachDistrictView == 'edit'">
            <fieldset class="content-group">
              <div class="mb-3">
                <button *ngIf="attachDistrictView == 'add'"
                        (click)="attachDistrictView = 'list';"
                        type="button"
                        class="btn btn-success float-end me-3">
                  <strong>List Attached District</strong>
                </button>
              </div>
            </fieldset>

            <fieldset class="content-group">
              <div class="mb-3 row">
                <label class="col-form-label col-lg-2">Office Type*</label>
                <div class="col-lg-10">
                  <select [disabled]="(attachDistrictView == 'edit')?true:false"
                          [ngModelOptions]="{standalone: true}" [(ngModel)]="attachOffice"
                          (change)="getAttachGroupName('attach')"
                          class="form-select">
                    <option value=""> Select Office Type</option>
                    <option *ngFor="let officeType of officeTypeList let i = index"
                            [attr.data-index]="i"
                            value="{{officeType.id}}">
                      {{ officeType.office_type }}
                    </option>
                  </select>
                  <div *ngIf="attachOfficetypeError && attachError">
                    <span class="text-danger fw-bold ms-1">*{{ attachOfficetypeError }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3 row">
                <label class="col-form-label col-lg-2">Group Name*</label>
                <div class="col-lg-10">
                  <select [disabled]="(attachDistrictView == 'edit')?true:false"
                          [ngModelOptions]="{standalone: true}" [(ngModel)]="attachGroupName"
                          class="form-select">
                    <option value=""> Select Group Name</option>
                    <option *ngFor="let group of attachGroupList let i = index"
                            [attr.data-index]="i"
                            value="{{group.id}}">
                      {{ group.group_name }}
                    </option>
                  </select>
                  <div *ngIf="attachGroupError && attachError">
                    <span class="text-danger fw-bold ms-1">*{{ attachGroupError }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3 row">
                <label class="col-form-label col-lg-2">Attach District*</label>
                <div class="col-lg-10">
                  <ng-multiselect-dropdown
                    [placeholder]="'Select District'"
                    [data]="dropdownList"
                    [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedDistrict"
                    [settings]="dropdownSettings"
                    (onSelect)="onItemSelect($event)"
                    (onSelectAll)="onSelectAll($event)">
                  </ng-multiselect-dropdown>
                  <div *ngIf="attachDistrictError && attachError">
                    <span class="text-danger fw-bold ms-1">*{{ attachDistrictError }}</span>
                  </div>
                </div>
              </div>

              <div class="mb-3 row">
                <div class="col-lg-12">
                  <button *ngIf="attachDistrictView == 'add'"
                          (click)="attachDistrictGroup('add')"
                          type="submit"
                          class="btn btn-primary float-end">
                    <strong>Save</strong>
                  </button>

                  <button *ngIf="attachDistrictView == 'edit'"
                          (click)="attachDistrictGroup('edit')"
                          type="submit"
                          class="btn btn-primary float-end mx-2">
                    <strong>Update</strong>
                  </button>

                  <button *ngIf="attachDistrictView == 'edit'"
                          (click)="cancelDistrictGroup()"
                          type="submit"
                          class="btn btn-danger float-end">
                    <strong>Cancel</strong>
                  </button>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="table-responsive">
            <table class="table" *ngIf="attachDistrictView == 'list'">
              <thead>
              <tr>
                <th *ngIf="state == 'Delhi'">S No.</th>
                <th>Office Type</th>
                <th>Group Name</th>
                <th>District</th>
                <th class="text-end">Action</th>
              </tr>
              </thead>

              <tbody *ngIf="!attachDistrictLoader && attachDistrictList.length">
              <tr *ngFor="let attach of attachDistrictList let i = index" [attr.data-index]="i">
                <td *ngIf="state == 'Delhi'">{{ i + 1 }}</td>
                <td>
                  <span class="text-capitalize">{{ attach.office_type }}</span>
                </td>
                <td>
                  <span class="text-capitalize">{{ attach.group_name }}</span>
                </td>
                <td>
                        <span class="badge bg-primary text-capitalize me-1"
                              *ngFor="let district of attach.districts | parameterSplit | keyvalue">
                            {{ district.value }}
                        </span>
                </td>
                <td class="text-end">
                  <div class="dropdown">
                    <button class="btn btn-link p-0" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <i class="icon-menu9"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                      <li>
                        <a class="dropdown-item" (click)="editDistrictAttached(attach)">
                          <i class="icon-pencil me-1"></i> Edit
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" (click)="deleteDistrictAttached(attach)">
                          <i class="icon-cross me-1"></i> Delete
                        </a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
              </tbody>
              <tbody *ngIf="!attachDistrictLoader && !attachDistrictList.length">
              <tr>
                <td colspan="12" class="text-center py-5">
                  <span class="badge bg-danger">No District Attached</span>
                </td>
              </tr>
              </tbody>
              <tbody *ngIf="attachDistrictLoader">
              <tr>
                <td colspan="12" class="text-center py-5">
                  <img src="/assets/images/load.gif" alt="Loading..."/>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
